import { render } from "./EventOrders.vue?vue&type=template&id=c2e1f24a&ts=true"
import script from "./EventOrders.vue?vue&type=script&lang=ts"
export * from "./EventOrders.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/tc-admin/tc-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__